import { Component } from '@angular/core';
import { DialogComponent, DialogService } from '../../services/modal-dialogs';
import { Message } from 'primeng/primeng';
import { Router } from '@angular/router';


export interface IUsageHistoryChartDialogModel {
    itemName: string;
    subTitle: string;
    message: string;
}


@Component({
    selector: 'stats-usage-history-chart-dialog',
    styleUrls: ['./stats.usage.history.chart.dialog.css'],
    templateUrl: './stats.usage.history.chart.dialog.html'
})
export class StatsUsageHistoryChartDialog extends DialogComponent<IUsageHistoryChartDialogModel, boolean> implements IUsageHistoryChartDialogModel {

    itemName: string;
    subTitle: string;
    message: string;

    constructor(dialogService: DialogService, public router: Router) {
        super(dialogService, router);
        this.chartConfig();
    }


    // //////////////////////////////////////
    // CHART STUFFS
    // //////////////////////////////////////

    data: any = '';

    msgs: Message[];

    chartConfig() {

        let currentTime = new Date();

        let year = currentTime.getFullYear();
        let lastYear = currentTime.getFullYear() - 1;

        this.data = {
            labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            datasets: [
                {
                    label: year,
                    data: [6500, 5900, 800],
                    fill: true,
                    backgroundColor: 'rgba(0,125,255,0.1)',
                    borderColor: '#08F'
                },
                {
                    label: lastYear,
                    data: [2800, 4800, 4000, 1900, 8600, 2700, 900, 810, 5600, 5500, 4000, 3000],
                    fill: true,
                    backgroundColor: 'rgba(0,0,0,0.05)',
                    borderColor: 'rgba(0,0,0,0.25)'
                }
            ]
        }
    }


    selectData(event) {
        this.msgs = [];
        this.msgs.push({ severity: 'info', summary: 'Data Selected', 'detail': this.data.datasets[event.element._datasetIndex].data[event.element._index] });
    }




    // ///////////////////////////////////////////
    // CONFIRM CLICK
    // ///////////////////////////////////////////
    confirm() {
        // we set dialog result as true on click on confirm button,
        // then we can get dialog result from caller code
        this.result = true;
        this.close();
    }


}
